import { Subject } from 'rxjs';
import { MapWifiRouter } from '../models/weavix-map.model';
import { PermissionAction } from '../permissions/permissions.model';
import { Utils } from '../utils/utils';
import { NetworkLocationService } from './network-location.service';
import { ProfileService } from './profile.service';
import { StateServiceBase, StateUpdate } from './state-base.service';

export class WifiRouterStateService extends StateServiceBase {
    wifiRouters = new Map<string, MapWifiRouter>();
    wifiRouters$ = new Subject<StateUpdate<MapWifiRouter>>();

    constructor(
        private readonly networkLocationService: NetworkLocationService,
        private readonly profileService: ProfileService,
    ) {
        super();
    }

    async loadData(c: any, accountId: string, facilityId?: string, tags?: string[]) {
        if (!this.profileService.hasPermission(PermissionAction.ViewWorkerLiveLook, facilityId)) return;
        this.wifiRouters = Utils.toMap(await this.networkLocationService.getFacilityWifiRouters(c, facilityId, false));
    }

    async stop() {
        super.stop();
        this.wifiRouters.clear();
    }

    protected async setupSubscriptions(c: any, accountId: string, facilityId?: string) {
        if (!this.profileService.hasPermission(PermissionAction.ViewWorkerLiveLook, facilityId)) return;
        return null;
    }
}
